import React from "react";
import { Helmet } from "react-helmet-async";
import "./UserGuide.css";

function RegulatedMedicine() {

  return (

    <div className="user-guide-page">

      {/* SEO META */}
      <Helmet>
        <title>Regulated Medicine | Drug Safety & CDSCO Guidelines</title>
        <meta
          name="description"
          content="Learn about regulated medicines in India, CDSCO authority, prescription drugs, OTC medicines, and safe medication guidelines."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://realgenericshop.com/regulated-medicine" />
      </Helmet>

      <div className="user-guide-container">

        <h1 className="user-guide-title">
          Regulated Medicine
        </h1>

        <div className="user-guide-content">

          <p>
            Medicines in India are strictly regulated to
            ensure safety, quality, and effectiveness
            for consumers.
          </p>

          <h3>Regulatory Authorities</h3>

          <ul>

            <li>
              Central Drugs Standard Control Organization (CDSCO)
            </li>

            <li>
              State Drug Control Departments
            </li>

          </ul>

          <h3>Prescription Medicines</h3>

          <p>
            Certain medicines require a valid prescription
            from a certified medical practitioner.
            These drugs should not be consumed
            without proper guidance.
          </p>

          <ul>

            <li>
              Antibiotics
            </li>

            <li>
              Controlled substances
            </li>

            <li>
              High-risk medications
            </li>

          </ul>

          <h3>Over-the-Counter (OTC) Medicines</h3>

          <p>
            OTC medicines can be purchased without
            a prescription but should still be used responsibly.
          </p>

          <h3>Why Regulation Matters</h3>

          <ul>

            <li>
              Ensures drug safety and quality
            </li>

            <li>
              Prevents misuse and abuse
            </li>

            <li>
              Protects public health
            </li>

          </ul>

          <h3>Important Advice</h3>

          <p>
            Always follow prescribed dosage and avoid
            self-medication. Improper use of medicines
            can lead to serious health risks.
          </p>

        </div>

      </div>

    </div>

  );

}

export default RegulatedMedicine;